import React, { useCallback, useContext } from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import Button from '../../../button/Button';
import { FuncType } from '../../../button/enum';
import { Size } from '../../../core/enum';
import Dropdown from '../../../dropdown/Dropdown';
import Menu from '../../../menu';
import Switch from '../../../switch/Switch';
import TableContext from '../../TableContext';
import { ColumnLock } from '../../enum';
import { Placements } from '../../../dropdown/enum';
import { $l } from '../../../locale-context';
const { Item } = Menu;
function findRecords(record, groups) {
    const { parent } = record;
    if (parent) {
        return parent.children || [];
    }
    const lock = record.get('lock');
    const group = groups.find(({ value }) => value === lock);
    if (group) {
        return group.records;
    }
    return [];
}
const ItemSuffix = function ItemSuffix(props) {
    const { record, index, records, groups } = props;
    const { prefixCls, tableStore: { columnHideable, columnTitleEditable, columnDraggable } } = useContext(TableContext);
    const changeLock = useCallback((lock) => {
        const oldLock = record.get('lock');
        const group = groups.find(({ value }) => value === lock);
        if (group) {
            record.set('sort', group.records.length);
        }
        record.set('lock', lock);
        const oldGroup = groups.find(({ value }) => value === oldLock);
        if (oldGroup) {
            oldGroup.records.filter(r => r !== record).forEach((r, sort) => r.set('sort', sort));
        }
    }, [record, groups]);
    const changeIndex = useCallback((newIndex) => {
        const oldSort = record.get('sort');
        const list = findRecords(record, groups);
        const [removed] = list.splice(oldSort, 1);
        if (removed) {
            list.splice(newIndex, 0, removed);
        }
        list.forEach((r, sort) => r.set('sort', sort));
    }, [record, groups]);
    const handleMenuClick = useCallback(action((arg) => {
        const { key } = arg;
        switch (key) {
            case 'rename':
                record.setState('editing', true);
                break;
            case 'unlock':
                changeLock(false);
                break;
            case 'left':
                changeLock(ColumnLock.left);
                break;
            case 'right':
                changeLock(ColumnLock.right);
                break;
            case 'top':
                changeIndex(0);
                break;
            case 'up':
                changeIndex(index - 1);
                break;
            case 'down':
                changeIndex(index + 1);
                break;
            default:
        }
    }), [record, index, changeLock, changeIndex]);
    const getTreeNodesMenus = () => {
        const lock = record.get('lock');
        const menus = [];
        if (columnTitleEditable && record.get('titleEditable') !== false) {
            menus.push(React.createElement(Item, { key: "rename" }, $l('Table', 'rename')));
        }
        if (columnDraggable && record.get('draggable') !== false) {
            if (!record.parent) {
                if (lock) {
                    menus.push(React.createElement(Item, { key: "unlock" }, $l('Table', 'unlock')));
                }
                else {
                    menus.push(React.createElement(Item, { key: "left" }, $l('Table', 'left_lock')), React.createElement(Item, { key: "right" }, $l('Table', 'right_lock')));
                }
            }
            if (index > 1) {
                menus.push(React.createElement(Item, { key: 'top' }, $l('Table', 'top')));
            }
            if (index > 0) {
                menus.push(React.createElement(Item, { key: "up" }, $l('Table', 'up')));
            }
            if (index < records.length - 1) {
                menus.push(React.createElement(Item, { key: "down" }, $l('Table', 'down')));
            }
        }
        if (menus.length) {
            return (React.createElement(Menu, { prefixCls: `${prefixCls}-dropdown-menu`, onClick: handleMenuClick }, menus));
        }
    };
    const menu = getTreeNodesMenus();
    return (React.createElement(React.Fragment, null,
        menu && (React.createElement(Dropdown, { overlay: menu, placement: Placements.bottomRight },
            React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "more_horiz", className: `${prefixCls}-customization-tree-treenode-hover-button` }))),
        React.createElement(Switch, { record: record, disabled: !columnHideable || record.get('hideable') === false || (record.parent && record.parent.get('hidden')), name: "hidden", value: false, unCheckedValue: true })));
};
ItemSuffix.displayName = 'ItemSuffix';
export default observer(ItemSuffix);
